import http from 'axios';

const state = {
  dict: {
    cutter: {
      text: '剪辑宝',
      path: '/cutter',
      bgc: '#2F58FE #872FFE',
      icon: '10-11jianjibao',
      materialType: 'video',
      materialStoreText: '视频库',
      materialApi: '/user/video/uploadVideo',
      materialStoreLink: '/workbench/elements/videos'
    },
    videoConverter: {
      text: '转换宝',
      path: '/videoConverter',
      bgc: '#64FFC0 #75E1E2',
      icon: '10-16zhuanhuanbao',
      materialType: 'video',
      materialStoreText: '视频库',
      materialApi: '/user/video/uploadVideo',
      materialStoreLink: '/workbench/elements/videos'
    },
    screenshot: {
      text: '截图宝',
      path: '/screenshot',
      bgc: '#FF6060 #FF51B5',
      icon: '10-15jietubao',
      materialType: 'image',
      materialStoreText: '图片库',
      materialApi: '/user/pic',
      materialStoreLink: '/workbench/elements'
    },
    videoSpeeder: {
      text: '变速宝',
      path: '/videoSpeeder',
      bgc: '#64B1F9 #7C4FFE',
      icon: '',
      materialType: 'video',
      materialStoreText: '视频库',
      materialApi: '/user/video/uploadVideo',
      materialStoreLink: '/workbench/elements/videos'
    },
    videoMerger: {
      text: '合并宝',
      path: '/videoMerger',
      bgc: '#3894FF #4AD9FF',
      icon: '',
      materialType: 'video',
      materialStoreText: '视频库',
      materialApi: '/user/video/uploadVideo',
      materialStoreLink: '/workbench/elements/videos'
    },
    audiocutter: {
      text: '音频宝',
      path: '/audiocutter',
      bgc: '#47E794 #BAE622',
      icon: '',
      materialType: 'audio',
      materialStoreText: '音频库',
      materialApi: '/user/music',
      materialStoreLink: '/workbench/elements/audios'
    },
    gifconverter: {
      text: 'GIF宝',
      path: '/gifconverter',
      bgc: '#FF4186 #FFA55D',
      icon: '',
      materialType: 'image',
      materialStoreText: '图片库',
      materialApi: '/user/pic',
      materialStoreLink: '/workbench/elements'
    },
    cropper: {
      text: '裁剪宝',
      path: '/cropper',
      bgc: '#FFB45C #FF4D4D',
      icon: '10-11jianjibao',
      materialType: 'video',
      materialStoreText: '视频库',
      materialApi: '/user/video/uploadVideo',
      materialStoreLink: '/workbench/elements/videos'
    }
  }
};

const getters = {
  dict: (state) => state.dict,
  list: (state) => Object.values(state.dict)
};

const mutations = {};

const actions = {
  async fetchViews({ state }) {
    const resp = await http.get('/common/applications');
    let { data: { data: respData = [] } = {} } = resp;
    // isPass 审核通过
    let mainData = respData.filter((v) => {
      return v && v.routerPath && v.routerPath.indexOf('/toolkit') > -1;
    });
    mainData = mainData.filter((v) => v.cornerMark != 3 && v.isPass == 0 && v.imageMarkColor && v.routerPath != null).sort((a, b) => a.sort - b.sort);
    let { dict: views = {} } = state;
    let newDict = {};
    mainData.map((item) => {
      let { routerPath = '' } = item;
      // if (routerPath == null) {
      //   routerPath = '';
      // }
      routerPath = routerPath.replace(/\/?toolkit/i, '');
      let viewName = routerPath[0] === '/' ? routerPath.slice(1) : routerPath;
      let formatedItem = {
        text: item.appName,
        path: routerPath,
        bgc: item.imageMarkColor ? item.imageMarkColor.replace(',', ' ') : void 0,
        icon: item.imageMark,
        iconUrl: item.iconUrl,
        origin: item
      };
      let materialTypeDict = {};
      if (item.materialType == 1) {
        materialTypeDict = {
          materialType: 'video',
          materialStoreText: '视频库',
          materialApi: '/user/video/uploadVideo',
          materialStoreLink: '/workbench/elements/videos'
        };
      }
      if (item.materialType == 2) {
        materialTypeDict = {
          materialType: 'audio',
          materialStoreText: '音频库',
          materialApi: '/user/video/uploadVideo',
          materialStoreLink: '/workbench/elements/videos'
        };
      }
      if (item.materialType == 3) {
        materialTypeDict = {
          materialType: 'image',
          materialStoreText: '图片库',
          materialApi: '/user/pic',
          materialStoreLink: '/workbench/elements'
        };
      }
      let storedItem = views[viewName];
      newDict[viewName] = { ...storedItem, ...formatedItem, ...materialTypeDict };
    });
    state.dict = newDict;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
